import { Schema, Node as ProseNode } from 'prosemirror-model'
import { Step } from 'prosemirror-transform'
import { EditorState } from 'prosemirror-state'

import { ArticleFlat } from 'types'

export const getDocumentFromJson = (
  articleElements: ArticleFlat['elements'],
  schema: Schema,
  seedEmpty: boolean = true,
) => {
  const seed = seedEmpty ? [schema.nodes.paragraph.create({})] : []

  const nodes: ProseNode[] = []
  for (const element of articleElements) {
    nodes.push(ProseNode.fromJSON(schema, element.data_json))
  }
  return schema.nodes.doc.create({}, nodes.length ? nodes : seed)
}

export const buildState = (
  elements: ArticleFlat['elements'],
  schema: Schema,
  extraSteps?: ArticleFlat['extra_steps'],
) => {
  const doc = getDocumentFromJson(elements, schema)
  const state = EditorState.create({ doc, schema })
  if (!extraSteps) return state

  const { tr } = state
  extraSteps.forEach((stepRow) => {
    const step = Step.fromJSON(schema, stepRow.data)
    tr.step(step)
  })
  return state.apply(tr)
}
